import React from 'react'
import { useTranslation } from 'react-i18next'

import { LoyaltyCardStampProgressMeter } from '@src/components/CustomerLoyaltyCard/StampProgressMeter'
import { ScallopedMaskSVG } from '@src/components/SVGS/ScallopedMaskSVG'

import { singleOrderCustomType } from './queries/getSingleOrderCustomType'
import {
  DeliveryContainer,
  BoldTitle,
  LightText,
  LoyaltyCardImage,
  StampInfo,
  LoyaltyCardContainer,
  LoyaltyCardContentContainer,
} from './SingleOrder.styles'
import { useFormatCurrency } from '@src/hooks/useFormatCurrency'
import { imageJitURL } from '@src/utils/imageJitURL'

export const LoyaltyCardStamps: React.FC<{
  myOrder: singleOrderCustomType
}> = ({ myOrder }) => {
  const { t } = useTranslation('singleOrder')
  const formatCurrency = useFormatCurrency()

  const { loyaltyCardStampInfo } = myOrder

  if (!loyaltyCardStampInfo?.length) {
    return null
  }

  return (
    <DeliveryContainer>
      <BoldTitle>{t('stamps_earned')}</BoldTitle>
      <LightText>
        {loyaltyCardStampInfo?.map((data, index) => (
          <LoyaltyCardContainer key={`${data.loyaltyCardName}-${index}`}>
            <LoyaltyCardContentContainer>
              <ScallopedMaskSVG scale={0.24} />
              <LoyaltyCardImage
                imageUrl={imageJitURL(data.loyaltyCardIcon, {
                  resize: {
                    width: 68,
                    height: 68,
                    fit: 'fill',
                  },
                })}
                scale={0.24}
              />
              <StampInfo loyaltyColor={data.loyaltyCardColor || '#00956a'}>
                {data.loyaltyCardName}
              </StampInfo>
            </LoyaltyCardContentContainer>
            <LoyaltyCardContentContainer>
              <StampInfo style={{ fontWeight: 'bold', fontSize: 12 }}>
                +{formatCurrency(data.amountEarnedOnOrder)}
              </StampInfo>
              {data.stampsEarnedUpToThisOrder !== 0 && (
                <LoyaltyCardStampProgressMeter
                  isSingleOrder
                  loyaltyCard={{
                    loyaltyCardColor: data.loyaltyCardColor,
                    loyaltyCardIcon: data.loyaltyCardIcon,
                    requiredStamps: data.requiredStamps,
                    netTotal: data.amountEarnedOnOrder,
                    stampsEarnedUpToThisOrder: data.stampsEarnedUpToThisOrder,
                  }}
                />
              )}
            </LoyaltyCardContentContainer>
          </LoyaltyCardContainer>
        ))}
      </LightText>
    </DeliveryContainer>
  )
}
